import ApiError from "../../errors/ApiError";
import { CREATE_ROOM_ERROR } from "./error-codes.constants";

export class CreateRoomError extends ApiError {
  constructor() {
    super(CREATE_ROOM_ERROR);
  }
}
